import { isPlatformBrowser, isPlatformServer } from '@angular/common';
import {
  Component,
  CUSTOM_ELEMENTS_SCHEMA,
  inject,
  makeStateKey,
  OnInit,
  REQUEST
} from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { loadSalesIQ } from '@repo/ui/lib/salesiq';
import { BaseWidget } from './widgets/base-widget/base-widget';
@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent extends BaseWidget implements OnInit {
  private readonly request = inject(REQUEST, { optional: true });
  
  constructor() {
    super();
  }

  ngOnInit() {
    if (isPlatformServer(this.platformId)) {
      this.transferState.set(makeStateKey(this.ua), this.request?.headers['user-agent'] ?? '');
    }

    if (isPlatformBrowser(this.platformId) && !this.shouldSkipHydration()) {
      // Skip SalesIQ on mobile devices
      const isMobile = /Mobi|Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
      );

      if (!isMobile) {
        loadSalesIQ();
      }
    }
  }
}
